import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const CommAutoPolicyUpdates = Loadable(
  lazy(() =>
    import("./CommAutoPolicyUpdates").then(({ CommAutoPolicyUpdates }) => ({
      default: CommAutoPolicyUpdates,
    }))
  )
);

export const CommAutoPolicyUpdatesRoutes = [
  {
    path: `/comm-automobile-policy/:customerId/updates/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <CommAutoPolicyUpdates />
      </AuthorizedRoute>
    ),
  },
]